'use client';
import './chat.scss';

import React, { FC, useEffect } from 'react';
import Script from 'next/script';
import { ChatPageProps } from '@/components/chat/types';
import ClonePlusDescription from './ClonePlusDescription';
import ClonePlusVideo from './ClonePlusVideo';
import { BiChevronsLeft, BiChevronsRight } from 'react-icons/bi';
import Image from 'next/image';

const ChatPage: FC<ChatPageProps> = ({ code, cloneExtra }) => {
  const [showMore, setShowMore] = React.useState(false);

  useEffect(() => {
    let obj: { main: Record<string, any>; video?: Record<string, any> } = {
      main: {
        id: 'main-clone',
        botId: code,
        targetDom: 'clone-placement',
      },
    };

    if (cloneExtra?.template === 'clonePlusVideo')
      obj = {
        ...obj,
        video: {
          id: 'video-widget',
          botId: cloneExtra.data.botId,
          targetDom: 'video-bot',
        },
      };

    (window as any).data = obj;

    return () => {
      (window as any).data = undefined;
    };
  }, [cloneExtra?.data?.botId, cloneExtra?.template, code]);

  if (!cloneExtra?.template) {
    return <></>;
  }

  const template: 'basic' | 'clonePlusDescription' | 'clonePlusVideo' = cloneExtra?.template;

  return (
    <React.Fragment>
      <Script src={process.env.NEXT_PUBLIC_CLONE_SCRIPT_URL} rel="preload" />

      <div
        className={`tw-grid ${
          template != 'basic' ? 'lg:tw-grid-cols-[375px_1fr]' : ''
        } tw-items-center tw-justify-center tw-p-[10px] tw-grid-cols-1 tw-h-[100svh] lg:tw-overflow-hidden tw-overflow-x-hidden tw-overflow-y-auto tw-gap-2 tw-relative `}
      >
        {template == 'clonePlusVideo' && showMore == true && (
          <div className="tw-w-full tw-flex tw-h-[35px] tw-bg-black  tw-items-center tw-rounded-xl tw-gap-5 lg:tw-hidden">
            <div
              className="tw-text-white tw-cursor-pointer tw-flex tw-items-center "
              onClick={() => {
                setShowMore((prev) => !prev);
              }}
            >
              <BiChevronsLeft />
              Back
            </div>
            <div className="tw-flex  tw-h-[35px] tw-gap-3 tw-w-[calc(100vw-40px)] tw-overflow-x-auto tw-overflow-y-hidden tw-pt-1">
              {cloneExtra?.externalLinks?.map((link, index) => (
                <a
                  key={index}
                  className="tw-w-[25px] tw-h-[25px] tw-cursor-pointer tw-bg-gray-100 tw-shrink-0 tw-rounded-[99px] tw-justify-center tw-items-center tw-flex"
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    priority
                    quality={100}
                    width={20}
                    height={20}
                    src={link.logo}
                    alt={`Social link ${index + 1}`}
                    title={`Social link ${index + 1}`}
                  />
                </a>
              ))}
            </div>
          </div>
        )}

        {template != 'basic' && (
          <>
            <div
              onClick={() => {
                setShowMore((prev) => !prev);
              }}
              className={`${
                template == 'clonePlusVideo' && showMore ? 'tw-hidden ' : 'tw-inline-flex '
              } tw-cursor-pointer lg:tw-hidden tw-absolute tw-right-0 tw-top-[14px] tw-z-[99999999] tw-h-11 tw-pl-4 tw-pr-2 tw-py-2 tw-bg-gray-200 tw-rounded-tl-[99px] tw-rounded-bl-[99px] tw-backdrop-blur-md tw-justify-center tw-items-center tw-gap-0.5  tw-text-gray-800 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal`}
            >
              {showMore ? 'Back' : 'More'}
              {showMore ? <BiChevronsLeft /> : <BiChevronsRight />}
            </div>

            <div
              className={`tw-w-full lg:tw-h-[94vh] lg:tw-overflow-y-auto  tw-h-full tw-flex tw-flex-col gap-2  tw-items-center lg:tw-justify-start lg:tw-block ${
                showMore ? 'tw-block' : 'tw-hidden'
              }`}
            >
              {template == 'clonePlusDescription' && <ClonePlusDescription cloneExtra={cloneExtra} />}

              {template == 'clonePlusVideo' && <ClonePlusVideo cloneExtra={cloneExtra} />}
            </div>
          </>
        )}

        <div
          className={`tw-w-full tw-h-full  tw-items-center tw-justify-center lg:flex ${
            showMore ? 'tw-hidden' : 'tw-flex'
          } `}
        >
          <div
            id="clone-placement"
            className={`tw-relative tw-shadow-xl tw-rounded-2xl  ${
              template == 'basic' ? 'lg:tw-max-w-[992px]' : ''
            }  tw-w-full tw-h-full`}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChatPage;
